import React from 'react';
import { Button, Result } from 'antd';

interface Props {
  children: React.ReactNode;
  fallback?: React.ReactNode;
}

interface State {
  hasError: boolean;
  message: string;
}

/**
 * React error boundary — render xatolari oq ekran ko'rsatish o'rniga
 * tushunarli xato ekranini ko'rsatadi.
 *
 * Ishlatish:
 *   <ErrorBoundary><YourComponent /></ErrorBoundary>
 */
export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, message: '' };
  }

  static getDerivedStateFromError(error: unknown): State {
    const message =
      error instanceof Error ? error.message : 'Noma\'lum xatolik yuz berdi';
    return { hasError: true, message };
  }

  componentDidCatch(error: unknown, info: React.ErrorInfo) {
    // logger import qilish circular dependency hosil qilishi mumkin,
    // shuning uchun to'g'ridan-to'g'ri console.error ishlatiladi
    console.error('[ErrorBoundary] Render xatosi:', error, info.componentStack);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div style={{ padding: '24px 16px', minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Result
            status="error"
            title="Ilovada xatolik yuz berdi"
            subTitle={this.state.message}
            extra={
              <Button type="primary" onClick={this.handleReload}>
                Qayta yuklash
              </Button>
            }
          />
        </div>
      );
    }

    return this.props.children;
  }
}
